
import React, { useEffect, useRef } from 'react';
import { useAnalytics } from '../hooks/useAnalytics';

const ContactForm = () => {
  const formContainerRef = useRef<HTMLDivElement>(null);
  const formId = 'zf_div_UQqk66jXxbMuf-MItAsnPgiNQif2o-9kRcbpoKjS9Y0';
  const { trackFormSubmission } = useAnalytics();
  
  useEffect(() => {
    const formLoaded = () => {
      console.log('Zoho form loaded');
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'form_view', {
          form_name: 'FlowCare Book A Visit',
          form_source: 'Zoho'
        });
      }
    };
    
    if (formContainerRef.current && !document.getElementById(formId)?.querySelector('iframe')) {
      const containerDiv = document.createElement('div');
      containerDiv.id = formId;
      containerDiv.style.padding = '0 !important';
      containerDiv.style.margin = '0 !important';
      
      // Apply styles directly to container
      formContainerRef.current.style.padding = '0';
      formContainerRef.current.style.margin = '0';
      formContainerRef.current.style.overflow = 'hidden';
      
      formContainerRef.current.appendChild(containerDiv);
      
      try {
        const f = document.createElement("iframe");
        f.src = 'https://forms.zohopublic.com/abbella/form/BookAVisit/formperma/UQqk66jXxbMuf-MItAsnPgiNQif2o-9kRcbpoKjS9Y0?zf_rszfm=1';
        f.style.border = "none";
        f.style.height = "344px";
        f.style.width = "100%";
        f.style.transition = "all 0.5s ease";
        f.style.overflow = "hidden";
        f.style.marginTop = "-80px"; // Doubled the negative margin to completely hide the black band
        f.setAttribute("scrolling", "no");
        f.setAttribute("aria-label", 'Book A Visit');
        
        f.onload = () => {
          formLoaded();
          
          // Apply additional styling after the iframe loads
          setTimeout(() => {
            console.log('Applying additional styling to iframe');
            if (f.contentWindow) {
              try {
                // Attempt to modify iframe content styles (may fail due to same-origin policy)
                const iframeDoc = f.contentWindow.document;
                const style = document.createElement('style');
                style.textContent = `
                  body { padding: 0 !important; margin: 0 !important; }
                  .zf-templateWidth { padding: 0 !important; }
                `;
                iframeDoc.head.appendChild(style);
              } catch (e) {
                console.log('Could not access iframe content due to same-origin policy');
              }
            }
          }, 500);
        };
        
        containerDiv.appendChild(f);
        
        // Add custom CSS to the main document specifically for the Zoho form
        const style = document.createElement('style');
        style.textContent = `
          #${formId} {
            padding: 0 !important;
            margin: 0 !important;
          }
          #${formId} iframe {
            margin-top: -80px !important; // Doubled the negative margin here as well
          }
        `;
        document.head.appendChild(style);
        
        window.addEventListener('message', function handleFormMessage(event) {
          const evntData = event.data;
          if (evntData && evntData.constructor === String) {
            const zf_ifrm_data = evntData.split("|");
            
            if (zf_ifrm_data.length > 0 && evntData.includes('formSubmitted')) {
              console.log('Zoho form submission detected!');
              trackFormSubmission('FlowCare Book A Visit', {
                form_source: 'Zoho',
                form_id: formId,
                conversion_type: 'lead'
              });
              
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'conversion', {
                  send_to: 'G-YD7PXLJ142',
                  event_category: 'form',
                  event_label: 'visit_form_submitted'
                });
              }
            }
            
            if (zf_ifrm_data.length === 2 || zf_ifrm_data.length === 3) {
              const zf_perma = zf_ifrm_data[0];
              const zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 15) + "px";
              const iframe = document.getElementById(formId)?.getElementsByTagName("iframe")[0];
              
              if (iframe && (iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0) {
                const prevIframeHeight = iframe.style.height;
                const zf_tout = zf_ifrm_data.length === 3;
                
                if (zf_tout) {
                  iframe.scrollIntoView();
                }
                
                if (prevIframeHeight !== zf_ifrm_ht_nw) {
                  if (zf_tout) {
                    setTimeout(function() {
                      iframe.style.height = zf_ifrm_ht_nw;
                    }, 500);
                  } else {
                    iframe.style.height = zf_ifrm_ht_nw;
                  }
                }
              }
            }
          }
        }, false);
      } catch (e) {
        console.error("Error setting up Zoho form:", e);
      }
    }
    
    return () => {
      if (formContainerRef.current) {
        const formDiv = document.getElementById(formId);
        if (formDiv) {
          formContainerRef.current.removeChild(formDiv);
        }
      }
    };
  }, [trackFormSubmission]);

  return (
    <div className="w-full bg-white rounded-xl shadow-md p-6 overflow-hidden">
      <h3 className="text-2xl font-bold text-abbella-ebony mb-3">Book Your Visit Today</h3>
      <p className="text-gray-500 text-sm mb-6">
        🌿 Book Your Free Care Assessment<br />
        Let's find the right care solution — no pressure, just support.
      </p>
      
      <div 
        ref={formContainerRef} 
        className="w-full overflow-hidden rounded-lg"
        style={{ padding: 0, margin: 0 }}
      />
    </div>
  );
};

export default ContactForm;
